import { makeStyles } from "@cirrus/ui-kit";
import {DefaultColors} from "@cirrus/legacy/app-components/app/styles/colors/colors-default";

export const useStyles = makeStyles({
  pdfContainer: {
    backgroundColor: DefaultColors.gray_420,
  },
  pdfDialog: {
  },
  container: {
  },
  dialog: {
    "&:hover .pdf-dialog-controls": {
      display: "flex"
    }
  },
})

